import { Link } from 'react-router-dom';
import Logo from '../assets/images/Logo.svg';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import alertIcon from '../assets/images/Alert.svg';
import pfasCycleMap from '../assets/images/Pfas_cycle_map.svg';
import remedGoals from '../assets/images/Remed_goals.svg';

function PfasCycle() {
  return (
    <>
      <div className='navigation'>
        <div className='logo'>
          <img src={Logo} alt='Quantum logo' />
        </div>
        <div className='nav'>
          <Link to='/pfasimpacts' className='pfas-btn-white-back'>
            <div className='nav-text-back'>Previous</div>
          </Link>
          <Link to='/'>
            <div className='nav-home'></div>
          </Link>
          <div className='nav-page-nr'>4/6</div>
          <Link to='/pfasdestruction' className='pfas-btn-blue-next'>
            <div className='nav-text-next'>Next</div>
          </Link>
        </div>
      </div>
      <div className='pfas-cycle pfas-container'>
        <Row>
          <div className='cycle'>
            <Col xs={12} lg={6}>
              <div className='text-left '>
                <div className='slogan'> Waste problem</div>
                <div className='headline'>PFAS Cycle</div>
                <div className='text'>
                  Most PFAS is generated as a liquid waste in chemical plants.
                  It then ends up in the environment as both an air and water
                  pollutant. PFAS can also end up in the environment as a result
                  of wastewater treatment plants contaminating nearby rivers.
                </div>
                <div className='headline'>PFAS Remediation</div>
                <div className='text'>
                  Most existing methods have limitations such as:
                  <li>Not readily available for real deployment</li>
                  <li>Not cost-efficient for real applications</li>
                  <li>Not zero-waste (treating 100% of PFAS waste) </li>
                </div>
                <div className='headline'>Principles</div>
                <div className='text'>
                  In order to design a successful initiative
                  three main remediation principles must be satisfied: 
                </div>
                <div className='cycle-explain'>
                  <img src={remedGoals} alt='' />
                </div>
              </div>
            </Col>
            <Col xs={12} lg={6}>
              <div className='image-right'>
                <div className='cycle-image'>
                  <img src={pfasCycleMap} alt='Pfas cycle visualization' />
                  {/* <img src={pfasCycle} alt='Pfas cycle visualization' /> */}

                  <div className='info-block'>
                    <div className='alert-logo'>
                      <img src={alertIcon} alt='Alert icon' />
                    </div>
                    <div className='alert-text'>
                      Finding mechanisms to destroy/remove PFAS from the
                      ecosystem would help alleviate a global environmental
                      crisis that we are facing.
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </div>
        </Row>
      </div>
    </>
  );
}

export default PfasCycle;
